import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      customMessage: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    const handleRetry = () => {
      this.setState({
        hasError: false,
        error: null,
      });
    };

    const handleReload = () => {
      window.location.reload();
    };
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const message =
        this.state.customMessage ||
        'We are sorry, something went wrong. Please try again or reload the page.';
      return (
        <Dialog open={this.state.hasError}>
          <DialogTitle data-testid="dialog-title">Oops!</DialogTitle>
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={handleRetry}>
              Try again
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={handleReload}
            >
              Reload Page
            </Button>
          </DialogActions>
        </Dialog>
      );
    }

    return this.props.children;
  }
}
